import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram } from '@mui/icons-material';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-copyright">
          © {currentYear} Jaka kao Majka. Sva prava zadržana.
        </div>
        <div className="footer-instagram">
          <a 
            href="https://www.instagram.com/jakakaomajka?igsh=MXNnbG00MHpzZnZhbg==" 
            target="_blank" 
            rel="noopener noreferrer"
            className="instagram-link"
          >
            <Instagram />
          </a>
        </div>
        <div className="footer-links">
          <Link to="/pravila-koriscenja">Pravila korišćenja</Link>
          <Link to="/o-meni">O meni</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 